import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const CARDS = [
  { num: "01", titleKey: "whyUs.support.card1.title", textKey: "whyUs.support.card1.text" },
  { num: "02", titleKey: "whyUs.support.card2.title", textKey: "whyUs.support.card2.text" },
  { num: "03", titleKey: "whyUs.support.card3.title", textKey: "whyUs.support.card3.text" },
];

function Support() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <SectionTitle
          title1={t("whyUs.support.title1")}
          title2={t("whyUs.support.title2")}
          text={t("whyUs.support.subtitle")}
          className="mx-auto max-w-[548px]"
        />

        <div className="mt-[25px] lg:mt-[50px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[16px] lg:gap-[25px]">
          <Fade cascade triggerOnce direction="up" damping={0.08}>
            {CARDS.map((card) => (
              <div
                key={card.num}
                className="bg-white border border-[#e4edf7] rounded-[24px] px-[25px] py-[30px] lg:py-[36px] flex flex-col gap-[16px]"
              >
                <div className="bg-[#e4edf7] inline-flex items-center justify-center self-start px-[10px] py-[4px] rounded-full">
                  <span className="font-['Inter'] font-bold text-[14px] text-[#1c385f]">{card.num}</span>
                </div>
                <div className="w-[40px] h-[2px] rounded-[1px] bg-[#1c385f]" />
                <p className="font-['Inter'] font-bold text-[16px] text-[#1c385f]">{t(card.titleKey)}</p>
                <p className="font-['Inter'] font-normal text-[14px] lg:text-[16px] leading-[1.6] text-[#435c7f]">
                  {t(card.textKey)}
                </p>
              </div>
            ))}
          </Fade>
        </div>
      </div>
    </section>
  );
}

export default Support;
